import TableDataRowMobile from "./TableDataRowMobile";

export default TableDataRowMobile;
